import classNames from 'classnames';
import styles from './CheckboxWithText.module.scss';

const CheckboxWithText = ({
  children,
  onChange,
  checked,
  name,
  className,
  titleClassName,
  size = 'small',
  isHtml,
}) => {
  return (
    <label
      className={classNames([styles.radio, className], {
        [styles.large]: size === 'large',
      })}
      itemScope
      itemType='https://schema.org/CheckAction'
    >
      <input
        name={name}
        type={'checkbox'}
        onChange={onChange}
        checked={checked}
        aria-label={name}
      />
      {isHtml ? (
        <div
          className={classNames([styles.checkBoxTitle, titleClassName])}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      ) : (
        <div className={classNames([styles.checkBoxTitle, titleClassName])}>
          {children}
        </div>
      )}
    </label>
  );
};

export default CheckboxWithText;
